import React from 'react';
import styles from './ProcessSection.module.scss';

// Массив с данными для первых 5 карточек
const stepsData = [
    {
        num: '#01',
        title: 'Отправка фотографий',
        text: 'Вы загружаете исходники (подойдут кадры даже с обычного телефона) в мессенджер или на почту. Коротко обсуждаем ваши пожелания и задачу.',
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 19.34 22.77" fill="white">
                <path xmlns="http://www.w3.org/2000/svg" d="M15.44,19.84l3.9-3.9L18,14.57l-1.56,1.56V12.06H14.46v4.07L12.9,14.57l-1.37,1.37Zm-3.91,2.93V20.82h7.81v1.95Zm-7.8-3.9a1.85,1.85,0,0,1-1.38-.58,1.89,1.89,0,0,1-.58-1.38V3.25a1.92,1.92,0,0,1,.58-1.38A1.88,1.88,0,0,1,3.73,1.3h6.83l5.85,5.86v2.95H14.46v-2H9.58V3.25H3.73V16.91H9.58v2Zm0-2v0Z"/>
            </svg>
        )
    },
    {
        num: '#02',
        title: 'Редактирование',
        text: 'Магия в действии: выравниваем перспективу, настраиваем правильный свет, убираем лишний визуальный шум и добавляем кадрам атмосферу уюта.',
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 21.36 21.36" fill="white">
                <path xmlns="http://www.w3.org/2000/svg" d="M6.41,6.77,3.35,3.71,4.8,2.25,7.87,5.32Zm3.81-2.43V0h2V4.34ZM17.66,18,14.59,15l1.46-1.46,3.06,3.07ZM16.05,6.77,14.59,5.32l3.07-3.07,1.45,1.46Zm1,4.37v-2h4.34v2ZM3.19,21.06.31,18.17A1,1,0,0,1,0,17.45a1,1,0,0,1,.31-.71l9.27-9.3a3.08,3.08,0,0,1,4.35,0,3.09,3.09,0,0,1,0,4.34l-9.3,9.28a1,1,0,0,1-1.44,0Zm7.13-8.56L10,12.14l-.37-.36-.35-.36-.36-.35.71.71ZM3.91,18.91l6.41-6.41L8.87,11.07,2.48,17.45Z"/>
            </svg>
        )
    },
    {
        num: '#03',
        title: 'Внесение правок',
        text: 'Присылаем фотографии с водяными знаками на согласование. Если хочется что-то изменить — без проблем, мы бесплатно вносим до 3-х правок.',
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17.8 17.8" fill="white">
                <path d="M3.56,10.68h7.12V8.9H3.56ZM3.56,8H14.24V6.23H3.56Zm0-2.67H14.24V3.56H3.56ZM0,17.8v-16A1.71,1.71,0,0,1,.52.52,1.71,1.71,0,0,1,1.78,0H16a1.69,1.69,0,0,1,1.25.52,1.72,1.72,0,0,1,.53,1.26V12.46A1.81,1.81,0,0,1,16,14.24H3.56Zm2.8-5.34H16V1.78H1.78V13.46Zm-1,0v0Z" />
            </svg>
        )
    },
    {
        num: '#04',
        title: 'Получение результата',
        text: 'Вы получаете итоговые фотографии, они сжаты и помечены водяными знаками, оригиналы фотографий высылаются после оплаты.',
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 18.73 18.73" fill="white">
                <path xmlns="http://www.w3.org/2000/svg" d="M2.08,18.73a2,2,0,0,1-1.47-.61A2,2,0,0,1,0,16.65V2.08A2,2,0,0,1,.61.61,2,2,0,0,1,2.08,0H16.65a2,2,0,0,1,1.47.61,2,2,0,0,1,.61,1.47V16.65a2.08,2.08,0,0,1-2.08,2.08Zm0-2.08H16.65V2.08H2.08Zm1-2.08H15.61L11.7,9.36,8.58,13.52,6.24,10.4Zm-1,2.08v0Z"/>
            </svg>
        )
    },
    {
        num: '#05',
        title: 'Оплата',
        text: 'Никаких рисков и скрытых платежей. Вы переводите оплату только в том случае, когда полностью довольны итоговой работой. После оплаты направляем оригиналы фотографий.',
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 13.22 25.45" fill="white">
                <path xmlns="http://www.w3.org/2000/svg" d="M5.23,25.45v-3A7,7,0,0,1,2,20.78a6.94,6.94,0,0,1-2-3.39l2.62-1.06a5.33,5.33,0,0,0,1.57,2.58,4.08,4.08,0,0,0,2.74.88,4.37,4.37,0,0,0,2.45-.65,2.23,2.23,0,0,0,1-2,2.53,2.53,0,0,0-.78-2A11,11,0,0,0,6,13.5a8.88,8.88,0,0,1-4.17-2.28A4.77,4.77,0,0,1,.71,8,4.45,4.45,0,0,1,2.19,4.42,5.67,5.67,0,0,1,5.23,3V0H8.06V3A5.72,5.72,0,0,1,11,4.26a5.9,5.9,0,0,1,1.67,2.46L10,7.85a3.54,3.54,0,0,0-1.2-1.7,3.53,3.53,0,0,0-2.12-.57,3.56,3.56,0,0,0-2.37.69A2.19,2.19,0,0,0,3.53,8,2.08,2.08,0,0,0,4.6,9.83a15.29,15.29,0,0,0,3.67,1.41A7.17,7.17,0,0,1,12,13.49,5.46,5.46,0,0,1,13.22,17a4.84,4.84,0,0,1-1.48,3.82,6.93,6.93,0,0,1-3.68,1.62v3Z"/>
            </svg>
        )
    }
];

export const ProcessSection: React.FC = () => {
    return (
        <section className={styles.sectionContainer}>
            {/* Заголовок с градиентным словом */}
            <h2 className={styles.mainTitle}>
                Процесс обработки <br />
                фотографий с <span className={styles.gradientText2}>Vision Aparts</span>
            </h2>

            <div className={styles.grid}>
                {/* Рендерим первые 5 шагов из массива */}
                {stepsData.map((step, index) => (
                    <div key={index} className={styles.card}>
                        <div className={styles.cardHeader}>
                            <div className={styles.cardTitleBlock}>
                                <span className={styles.stepNum}>{step.num}</span>
                                <h3 className={styles.stepTitle}>{step.title}</h3>
                            </div>
                            <div className={styles.iconWrapper}>
                                {step.icon}
                            </div>
                        </div>
                        <p className={styles.cardText}>{step.text}</p>
                    </div>
                ))}

                {/* 6-й блок: Призыв к действию (CTA) */}
                <div className={styles.ctaCard}>
                    <div className={styles.ctaTop}>
                        Мы ценим ваше время. Первые варианты обработки будут готовы уже{' '}
                        <span className={styles.gradientText}>через 24-48 часов</span> после обсуждения задачи
                    </div>

                    <div className={styles.divider}></div>

                    <div className={styles.ctaBottom}>
                        <div className={styles.ctaBottomText}>
                            Пришлите тестовую фотографию прямо сейчас, и мы покажем, как может выглядеть{' '}
                            <span className={styles.gradientText}>ваш интерьер</span>
                        </div>
                        <button className={styles.btnPrimary}>
                            Заказать
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};